import React from "react";
import Card from "../../common/Card";
import { GraduationCap } from "@phosphor-icons/react";

const Educations = () => {
    return <Card title={"التعليم"} icon={<GraduationCap size={32} />}></Card>;
};

export default Educations;
